/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
import dynamic from 'next/dynamic';
import { Container, MapTo } from '@adobe/aem-react-editable-components';
import '../../libs/aemComponents/Container';
import '../../libs/aemComponents/ExperienceFragment';
import {
  EditableHTLWrapper,
  StaticWrapper,
  CardHorizontalMini,
  CardCarouselContainer,
  CardHorizontalFeature,
  CardLayered,
  CardVertical,
  RichText,
  BannerLayered,
  LinkList,
  AccordionContainer,
  BrandRibbon,
  IconBlock,
  CobrandCardHorizontalFlexible,
  LinkBanner,
  GeneralMessage,
  Hero,
  VariableColumnContainer,
  Mosaic,
  MiniCardCarouselContainer,
  CarouselGallery,
  BannerText,
  DataBlock,
  Footer,
  NavigationContainerWrapper,
  NavigationUtilityLinkWrapper,
  NavigationWrapper,
  Text,
  Media,
  AccordionContainerEnhanced,
  BannerFeature,
  TabContainer,
  CardSummary,
} from '@marriott/mi-common-static-components';
import { respGridUtil } from '@marriott/mi-headless-utils';
import {
  TabbedSearchForm,
  SearchFormEditable,
  MeetingsAndEventsSearchFormEditable,
  SearchForm,
} from '@marriott/mi-shop-components';

import { OfferCardCarousel } from '@marriott/mi-offers-components';

import { HeroBanner } from '@marriott/mi-homepage-components';

import { MMNComponentEditable } from '@marriott/mi-ppv5-components';

import { MerchandisingSmallBanner } from '@marriott/mi-merch-components';

import { GroupSearchFormDynamic, GroupSearchForm } from '@marriott/mi-groups-components';

const FooterDynamic = dynamic(() => import('@marriott/mi-common-static-components').then(module => module.Footer), {
  ssr: true,
});

export const AEM_REACT_MAPPING = {
  [`mi-aem-common-spa/components/common/staticwrapper`]: StaticWrapper,
  [`mi-aem-common-spa/components/content/richtext`]: RichText,
  [`mi-aem-common-spa/components/content/cardhorizontalmini`]: CardHorizontalMini,
  [`mi-aem-common-spa/components/content/cardlayered`]: CardLayered,
  [`mi-aem-common-spa/components/content/cardcarouselcontainer`]: CardCarouselContainer,
  [`mi-aem-common-spa/components/content/cardvertical`]: CardVertical,
  [`mi-aem-common-spa/components/content/cardhorizontalfeature`]: CardHorizontalFeature,
  [`mi-aem-common-spa/components/content/bannerlayered`]: BannerLayered,
  [`mi-aem-common-spa/components/content/linklist`]: LinkList,
  [`mi-aem-common-spa/components/content/accordioncontainer`]: AccordionContainer,
  [`mi-aem-common-spa/components/content/brandribbon`]: BrandRibbon,
  [`mi-aem-common-spa/components/content/iconblock`]: IconBlock,
  [`mi-aem-common-spa/components/content/cobrandcardhorizontalflexible`]: CobrandCardHorizontalFlexible,
  [`mi-aem-common-spa/components/content/linkbanner`]: LinkBanner,
  [`mi-aem-common-spa/components/content/generalmessage`]: GeneralMessage,
  [`mi-aem-common-spa/components/content/hero`]: Hero,
  [`mi-aem-common-spa/components/content/mosaic`]: Mosaic,
  [`mi-aem-common-spa/components/content/bannertext`]: BannerText,
  [`mi-aem-common-spa/components/content/variablecolumncontainer`]: VariableColumnContainer,
  [`mi-aem-common-spa/components/content/carouselgallery`]: CarouselGallery,
  [`mi-aem-common-spa/components/content/datablock`]: DataBlock,
  [`mi-aem-common-spa/components/experiencefragment`]: Container,
  [`mi-aem-common-spa/components/content/card-mini-carousel-container`]: MiniCardCarouselContainer,
  [`mi-aem-common-spa/components/content/accordioncontainerenhanced`]: AccordionContainerEnhanced,
  [`mi-aem-common-spa/components/content/text`]: Text,
  [`mi-aem-common-spa/components/content/bannerfeature`]: BannerFeature,
  [`mi-aem-common-spa/components/content/tabcontainer`]: TabContainer,
  [`mi-aem-common-spa/components/content/media`]: Media,
  [`mi-aem-common-spa/components/content/cardsummary`]: CardSummary,

  //Shop Component Mapping
  [`mi-aem-shop-spa/components/content/homepagesearch/v1/homepagesearch`]: SearchFormEditable,
  [`mi-aem-shop-spa/components/content/tabbedsearchformwrapper/v1/tabbedsearchformwrapper`]: TabbedSearchForm,
  [`mi-aem-shop-spa/components/content/meetingssearchform/v1/meetingssearchform`]: MeetingsAndEventsSearchFormEditable,
  [`mi-aem-shop-spa/components/content/searchform/v1/searchform`]: SearchForm,
  [`mi-aem-shop-spa/components/content/baselinesearchform/v1/baselinesearchform`]: SearchFormEditable,

  //Homepage mapping
  [`mi-aem-homepage-spa/components/content/herobanner`]: HeroBanner,
  ['mi-aem-homepage-spa/components/content/universal-footer']: Footer,
  [`mi-aem-homepage-spa/components/content/global-navigation`]: NavigationContainerWrapper,
  [`mi-aem-homepage-spa/components/content/utilityNavigation`]: NavigationUtilityLinkWrapper,
  [`mi-aem-homepage-spa/components/content/primaryNavigation`]: NavigationWrapper,

  //offers component maping
  [`mi-aem-offers-spa/components/offers-cards`]: OfferCardCarousel,

  //ppv5 components mapping
  [`mi-aem-common-spa/components/content/mmn-container`]: MMNComponentEditable,
  //Group search form component
  [`mi-aem-groups/components/content/groupsearchform`]: GroupSearchForm,

  [`mi-aem-common-spa/components/content/merchandisingsmallbanner`]: MerchandisingSmallBanner,
};

export const defineComponentMapping = (allowedComponents, pagePath, isAuthorMode, pageProps) => {
  MapTo(`mi-aem-common-spa/components/common/staticwrapper`)(StaticWrapper);
  MapTo(`mi-aem-common-spa/components/content/richtext`)(RichText);
  MapTo(`mi-aem-common-spa/components/content/cardhorizontalmini`)(CardHorizontalMini);
  MapTo(`mi-aem-common-spa/components/content/cardlayered`)(CardLayered);
  MapTo(`mi-aem-common-spa/components/content/cardcarouselcontainer`)(props => (
    <CardCarouselContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
  ));
  MapTo(`mi-aem-common-spa/components/content/cardvertical`)(CardVertical);
  MapTo(`mi-aem-common-spa/components/content/cardhorizontalfeature`)(props => (
    <div className="card-horizontal-feature-wrapper">
      <CardHorizontalFeature {...props} />
    </div>
  ));
  MapTo(`mi-aem-common-spa/components/content/bannerlayered`)(BannerLayered);
  MapTo(`mi-aem-common-spa/components/content/linklist`)(LinkList);
  MapTo(`mi-aem-common-spa/components/content/accordioncontainer`)(props => (
    <AccordionContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
  ));
  MapTo(`mi-aem-common-spa/components/content/brandribbon`)(BrandRibbon);
  MapTo(`mi-aem-common-spa/components/content/iconblock`)(IconBlock);
  MapTo(`mi-aem-common-spa/components/content/linkbanner`)(LinkBanner);
  MapTo(`mi-aem-common-spa/components/content/generalmessage`)(GeneralMessage);
  MapTo(`mi-aem-common-spa/components/content/hero`)(Hero);
  MapTo(`mi-aem-common-spa/components/content/mosaic`)(Mosaic);
  MapTo(`mi-aem-common-spa/components/content/bannertext`)(BannerText);
  MapTo(`mi-aem-common-spa/components/content/variablecolumncontainer`)(props => (
    <VariableColumnContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
  ));
  MapTo(`mi-aem-common-spa/components/content/carouselgallery`)(CarouselGallery);
  MapTo(`mi-aem-common-spa/components/content/datablock`)(DataBlock);
  MapTo(`mi-aem-common-spa/components/content/card-mini-carousel-container`)(
    props => {
      return <MiniCardCarouselContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />;
    },
    {
      isEmpty: true,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/mmn-container`)(
    props => <MMNComponentEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'MMNComponent',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/merchandisingsmallbanner`)(
    props => <MerchandisingSmallBanner {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'MerchandesingSmallBanner',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/cobrandcardhorizontalflexible`)(CobrandCardHorizontalFlexible, {
    emptyLabel: 'CobrandCardHorizontalFlexible',
    isEmpty: false,
  });

  MapTo(`mi-aem-common-spa/components/content/accordioncontainerenhanced`)(props => (
    <AccordionContainerEnhanced {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
  ));
  MapTo(`mi-aem-common-spa/components/content/cardsummary`)(CardSummary);
  MapTo(`mi-aem-common-spa/components/content/text`)(props => <Text {...props} />);
  MapTo(`mi-aem-common-spa/components/content/bannerfeature`)(props => <BannerFeature {...props} />);
  MapTo(`mi-aem-common-spa/components/content/tabcontainer`)(props => (
    <TabContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
  ));
  MapTo(`mi-aem-common-spa/components/content/media`)(props => (
    <Media {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
  ));

  // Shop Components
  MapTo(`mi-aem-shop-spa/components/content/homepagesearch/v1/homepagesearch`)(SearchFormEditable);
  MapTo(`mi-aem-shop-spa/components/content/tabbedsearchformwrapper/v1/tabbedsearchformwrapper`)(
    props => <TabbedSearchForm {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'TabbedSearchForm',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-shop-spa/components/content/meetingssearchform/v1/meetingssearchform`)(
    props => <MeetingsAndEventsSearchFormEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'MeetingsAndEventsSearchForm',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-groups/components/content/groupsearchform`)(
    props => (isAuthorMode ? <GroupSearchForm {...props} /> : <GroupSearchFormDynamic {...props} />),
    {
      emptyLabel: 'GroupSearchForm',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-shop-spa/components/content/searchform/v1/searchform`)(
    props => <SearchForm {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'SearchForm',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-shop-spa/components/content/baselinesearchform/v1/baselinesearchform`)(props => (
    <SearchFormEditable {...props} currentLocale={pageProps.currentLocale} />
  ));

  //Homepage components
  MapTo(`mi-aem-homepage-spa/components/content/herobanner`)(props => (
    <HeroBanner {...props} isAuthorMode={isAuthorMode} />
  ));

  //Offers components
  MapTo(`mi-aem-offers-spa/components/offers-cards`)(
    props => (
      <OfferCardCarousel
        {...props}
        offersData={pageProps.productSpecificResponse}
        isAuthorMode={isAuthorMode}
        acceptLanguage={pageProps?.currentLocale}
        requestId={pageProps?.requestId}
        cookie={pageProps?.headersData['cookie']}
      />
    ),
    {
      emptyLabel: 'Offers Card Carousel',
      isEmpty: false,
    }
  );

  const ExperienceFragmentVariationConfig = {
    emptyLabel: 'Experience Fragment',

    isEmpty: function (props) {
      return !props || !props.configured;
    },
  };

  MapTo(`mi-aem-common-spa/components/experiencefragment`)(props => {
    return (
      <Container
        isInEditor
        {...props}
        isPage={false}
        model={respGridUtil(props?.model)}
        className={props?.model?.styleclass}
      />
    );
  }, ExperienceFragmentVariationConfig);
  MapTo(`mi-aem-homepage-spa/components/content/universal-footer`)(props =>
    isAuthorMode ? (
      <Footer {...props} isAuthorMode={isAuthorMode} />
    ) : (
      <FooterDynamic {...props} isAuthorMode={isAuthorMode} />
    )
  );
  MapTo(`mi-aem-homepage-spa/components/content/global-navigation`)(
    props => <NavigationContainerWrapper {...props} isAuthorMode={isAuthorMode} />,
    { emptyLabel: 'NavigationContainerWrapper', isEmpty: false }
  );
  MapTo(`mi-aem-homepage-spa/components/content/utilityNavigation`)(NavigationUtilityLinkWrapper);
  MapTo(`mi-aem-homepage-spa/components/content/primaryNavigation`)(NavigationWrapper);

  const existingMappings = Object.keys(AEM_REACT_MAPPING);
  if (allowedComponents) {
    allowedComponents.forEach(mapping => {
      const baseModelPath = '/jcr:content/root/responsivegrid/';
      const componentPath = mapping.path.split(baseModelPath)[1];

      if (existingMappings.indexOf(componentPath) === -1) {
        MapTo(componentPath)(EditableHTLWrapper, {
          emptyLabel: mapping.title,
          isEmpty: false,
        });
      } else {
        console.log('mapping exists', componentPath);
      }
    });
  }
};
